import { useState, useEffect } from "react";
import { Dialog, Box, Accordion, AccordionSummary, AccordionDetails, Typography, TextField } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ColumnSelector from '../DataProfiling/ColumnSelector';
import axios from 'axios';
import toast from 'react-hot-toast';
import heartLoading from '../../../assests/heartLoading.gif';
// import { useParams } from 'react-router-dom';

const ColumnSelection = ({nextStep, columnsList, id}) => {
    // const { id } = useParams();

    const [fetchedFiles, setFetchedFiles] = useState([]);
    const [expandedAccordion, setExpandedAccordion] = useState(columnsList[0]?.name || '');
    const [columnSearch, setColumnSearch] = useState(() => {
        const initial = {};
        return initial;
      });
    const [columnSubmitting, setColumnSubmitting] = useState(false);
    const [savingColumns, setSavingColumns] = useState(false);
    const [profilingColumns, setProfilingColumns] = useState(false);
    const [columnSelection, setColumnSelection] = useState(() => {
        const initial = {};
        columnsList.forEach(file => {
          initial[file.name] = [];
        });
        return initial;
      });
    const [columnDetails, setColumnDetails] = useState(() => {
        const initial = {};
        columnsList.forEach(file => {
          initial[file.name] = {};
        });
        return initial;
      });
    const [localLoading, setLocalLoading] = useState(false);

    const handleToggleColumn = (fileName, colId) => {
        setColumnSelection(prev => {
          const already = prev[fileName] || [];
          return {
            ...prev,
            [fileName]: already.includes(colId)
              ? already.filter(id => id !== colId)
              : [...already, colId]
          };
        });
      };
    const handleSelectAllColumns = (fileName, allColIds) => {
        setColumnSelection(prev => {
          const already = prev[fileName] || [];
          const allSelected = already.length === allColIds.length;
          return {
            ...prev,
            [fileName]: allSelected ? [] : allColIds
          };
        });
      };
    const handleColumnSearchChange = (fileName, value) => {
        setColumnSearch(prev => ({ ...prev, [fileName]: value }));
      };
    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpandedAccordion(isExpanded ? panel : false);
      };
    const handleCdeChange = (fileName, colId, value) => {
        setColumnDetails(prev => ({
          ...prev,
          [fileName]: {
            ...prev[fileName],
            [colId]: {
              ...prev[fileName][colId],
              cde: value
            }
          }
        }));
      };
    const handleDescriptionChange = (fileName, colId, value) => {
        setColumnDetails(prev => ({
          ...prev,
          [fileName]: {
            ...prev[fileName],
            [colId]: {
              ...prev[fileName][colId],
              description: value
            }
          }
        }));
      };
    const handleMetadataChange = (fileName, colId, value) => {
        setColumnDetails(prev => ({
          ...prev,
          [fileName]: {
            ...prev[fileName],
            [colId]: {
              ...prev[fileName][colId],
              metadata: value
            }
          }
        }));
      };
    const handleTransformationLogicChange = (fileName, colId, value) => {
        setColumnDetails(prev => ({
          ...prev,
          [fileName]: {
            ...prev[fileName],
            [colId]: {
              ...prev[fileName][colId],
              transformationLogic: value
            }
          }
        }));
      };
    const handleStartProfiling = async () => {
        // Validate: at least one column selected per file and all details filled
        const allSelected = (id ? fetchedFiles : columnsList).every(file => {
          const selected = columnSelection[file.name] || [];
          return selected.length > 0 && selected.every(colId => {
            const details = columnDetails[file.name]?.[colId] || {};
            return details.description && details.description.trim() !== '';
          });
        });
        if (!allSelected) {
          toast.error('Please select at least one column and fill CDE/Description for each.');
          return;
        }
        setProfilingColumns(true);
        // Build payload
        const schema_list = (id ? fetchedFiles : columnsList).map(file => ({
          name: file.name,
          path: file.path,
          source: file.source,
          columns: (columnSelection[file.name] || []).map(colId => {
            const col = file.columns.find(c => c.id === colId);
            const details = columnDetails[file.name]?.[colId] || {};
            return {
              id: col.id,
              name: col.name,
              type: col.type,
              cde: details.cde || false,
              description: details.description || '',
              metadata: details.metadata || '',
              transformationLogic: details.transformationLogic || ''
            };
          })
        }));

        const payload = {
          product_id:  id,
          schema_list
        }
        try {
          // Dummy POST API call
          const  respone = await axios.post(`${process.env.REACT_APP_API_URL}/save-schema-metadata`, payload);
          if (respone.status === 200 || 201 ||202){
            
            if(
              respone?.data.status ===  "success"
            ){
              startProfiling(id);
        // setProfilingColumns(false);
              // nextStep()
            }
          }
          // nextStep();

        } catch (error) {
          console.error('Profiling API failed (expected):', error);
          toast.error('Profiling API failed (but proceeding)...');
        // setProfilingColumns(false);
        }
      };

      const startProfiling = async (id) => {
        try {
          // Dummy POST API call
          const  respone = await axios.post(`${process.env.REACT_APP_API_URL}/trigger_profiling/${id}`);
          if (respone.status === 200 || 201 ||202){
            toast.success("Profiling Iniated Successfully")
            setProfilingColumns(false);
                  nextStep()
          }
          // nextStep();

        } catch (error) {
          console.error('Profiling API failed (expected):', error);
          toast.error('Profiling API failed, Please try again');
        setProfilingColumns(false);
        }
      }

      const handleSaveProfiling = async () => {
        // Validate: at least one column selected per file and all details filled
        const allSelected = (id ? fetchedFiles : columnsList).every(file => {
          const selected = columnSelection[file.name] || [];
          return selected.length > 0 && selected.every(colId => {
            const details = columnDetails[file.name]?.[colId] || {};
            return details.description && details.description.trim() !== '';
          });
        });
        // if (!allSelected) {
        //   toast.error('Please select at least one column and fill CDE/Description for each.');
        //   return;
        // }
        setSavingColumns(true);
        // Build payload
        const schema_list = (id ? fetchedFiles : columnsList).map(file => ({
          name: file.name,
          path: file.path,
          source: file.source,
          columns: (columnSelection[file.name] || []).map(colId => {
            const col = file.columns.find(c => c.id === colId);
            const details = columnDetails[file.name]?.[colId] || {};
            return {
              id: col.id,
              name: col.name,
              type: col.type,
              cde: details.cde || false,
              description: details.description || '',
              metadata: details.metadata || '',
              transformationLogic: details.transformationLogic || ''
            };
          })
        }));

        const payload = {
          product_id:  id,
          schema_list
        }
        try {
          // Dummy POST API call
          const  respone = await axios.post(`${process.env.REACT_APP_API_URL}/save-schema-only`, payload);
          if (respone.status === 200 || 201 ||202){
            if(
              respone?.data.status ===  "success"
            ){
              setSavingColumns(false)
              toast.success('Column Selection Saved Successfully');
              // nextStep()
            }
          }
          // nextStep();

        } catch (error) {
          console.error('Column Selection saveSave failed (expected):', error);
          toast.error('Column Selection save API failed (but proceeding)...');
        setSavingColumns(false);
        }
      };
  
    const allSelected = (id ? fetchedFiles : columnsList).every(file => {
      const selected = columnSelection[file.name] || [];
      return selected.length > 0 && selected.every(colId => {
        const details = columnDetails[file.name]?.[colId] || {};
        return details.description && details.description.trim() !== '';
      });
    });

    useEffect(() => {
      if (!id) return;
      const fetchSavedSchema = async () => {
        try {
          setLocalLoading(true);
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/get-schema-metadata/${id}`);
          if (response.status === 200 && response.data && Array.isArray(response.data.schema_list)) {
            const savedSchema = response.data.schema_list;
            setFetchedFiles(savedSchema);
            // Prepopulate columnSelection and columnDetails
            const newSelection = {};
            const newDetails = {};
            savedSchema.forEach(file => {
              newSelection[file.name] = file.columns.filter(col => col.isSelected).map(col => col.id);
              newDetails[file.name] = {};
              file.columns.forEach(col => {
                newDetails[file.name][col.id] = {
                  cde: col.cde || false,
                  description: col.description || '',
                  metadata: col.metadata || '',
                  transformationLogic: col.transformationLogic || ''
                };
              });
            });
            setColumnSelection(newSelection);
            setColumnDetails(newDetails);
          }
          setLocalLoading(false);
        } catch (error) {
          setLocalLoading(false);
        }
      };
      fetchSavedSchema();
    }, [id]);

  

    if (localLoading) {
      return (
        <div className="fixed inset-0 bg-white flex items-center justify-center z-50 w-full h-full">
                   <div className="flex flex-col items-center space-y-3">
                     <img src={heartLoading} alt="Loading..." className="h-30" />
                     <span className="text-gray-700 text-[20px]">
                     Hang tight! The resources are loading...
                     </span>
                   </div>
                 </div>
      );
    }

    const filesToShow = id ? fetchedFiles : columnsList;

    return(
      <div className="max-w-[90%] mx-auto px-4 py-6">  
        <Box className="bg-white rounded-lg shadow-lg border border-gray-100">
          {/* Header Section */}
          <div className="px-8 py-6 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-white">
            <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4">
              <div>
                <h2 className="text-2xl font-bold text-[#bb1ccc] mb-2">Select Columns to Profile</h2>
                <p className="text-gray-600 text-sm">Select columns to analyze data patterns and quality metrics.</p>
        </div>
              <div className="flex flex-wrap gap-3">
        <button
                  className="px-6 py-2.5 rounded-lg bg-[#bb1ccc] text-white font-medium hover:bg-[#000080] transition-colors duration-200 shadow-md hover:shadow-lg"
            onClick={() => {
              // Select all columns for all files and set business description to 'N/A'
              const newSelection = {};
              const newDetails = {};
              filesToShow.forEach(file => {
                newSelection[file.name] = file.columns.map(col => col.id);
                newDetails[file.name] = {};
                file.columns.forEach(col => {
                  newDetails[file.name][col.id] = {
                    cde: false,
                          description: 'N/A',
                          metadata: '',
                          transformationLogic: ''
                  };
                });
              });
              setColumnSelection(newSelection);
              setColumnDetails(newDetails);
            }}
          >
            Select All 
          </button>
        <button
                  className={`px-6 py-2.5 rounded-lg font-medium transition-all duration-200 ${
                    ( savingColumns) 
                      ? 'bg-gray-100 text-gray-500 cursor-not-allowed' 
                      : 'bg-[#bb1ccc] text-white hover:bg-[#000080] shadow-md hover:shadow-lg'
                  }`}
            onClick={handleSaveProfiling}
                  disabled={ savingColumns}
          >
            {savingColumns ? 'Saving...' : 'Save'}
          </button>
          <button
                  className={`px-6 py-2.5 rounded-lg font-medium transition-all duration-200 ${
                    (!allSelected || profilingColumns) 
                      ? 'bg-gray-100 text-gray-500 cursor-not-allowed' 
                      : 'bg-[#bb1ccc] text-white hover:bg-[#000080] shadow-md hover:shadow-lg'
                  }`}
            onClick={handleStartProfiling}
            disabled={!allSelected || profilingColumns}
          >
            {profilingColumns ? 'Starting...' : 'Start Profiling'}
          </button>
        </div>
        </div>
          </div>
       
          {/* Content Section */}
          <div className="p-6">
        {filesToShow.map((file, idx) => {
          // Filter columns by search
          const search = columnSearch[file.name] || '';
          const filteredColumns = file.columns.filter(col =>
            col.name.toLowerCase().includes(search.toLowerCase()) ||
            col.type.toLowerCase().includes(search.toLowerCase())
          );
          return (
                <div key={file.name} className="mb-3">
                  {/* Column count badge above accordion */}
                  <div className="flex justify-end mb-2">
                    <span className={`text-xs px-3 py-1 rounded-full font-medium shadow-md ${
                      (columnSelection[file.name]?.length || 0) > 0 
                        ? 'bg-green-500 text-white' 
                        : 'bg-gray-300 text-gray-600'
                    }`}>
                      {columnSelection[file.name]?.length || 0} column{(columnSelection[file.name]?.length || 0) !== 1 ? 's' : ''} selected
                    </span>
                  </div>
            <Accordion
              onChange={handleAccordionChange(file.name)}  
                    sx={{ 
                      mb: 3,
                      '&:before': { display: 'none' },
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      borderRadius: '12px',
                      overflow: 'hidden'
                    }}
                    className="border border-gray-200"
            >
                  <AccordionSummary 
                    expandIcon={<ExpandMoreIcon sx={{color: "#bb1ccc", fontSize: "24px"}} />} 
                    sx={{
                      backgroundColor: '#f8fafc',
                      '&:hover': { backgroundColor: '#f1f5f9' },
                      transition: 'background-color 0.2s ease'
                    }}
                  >
                    <div className="flex flex-col">
                      <Typography sx={{ 
                        fontWeight: '700', 
                        color: "black", 
                        fontSize: "16px",
                        mb: 0.5
                      }}>
                        {file.name}
                      </Typography>
                      <Typography variant="caption" sx={{
                        color: "gray.600",   
                        fontSize:"13px"
                      }}>
                        {file.tableDescription}
                      </Typography>
                </div>
              </AccordionSummary>
                  <AccordionDetails sx={{ 
                    backgroundColor: 'white',
                    borderTop: '1px solid #e5e7eb',
                    padding: '24px'
                  }}>
                    <div className="mb-4">
                <TextField
                  size="small"
                  variant="outlined"
                  placeholder="Search columns..."
                  value={columnSearch[file.name] || ''}
                  onChange={e => handleColumnSearchChange(file.name, e.target.value)}
                        sx={{ 
                          width: '100%',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                          '&.Mui-focused fieldset': {
                            borderColor: '#bb1ccc',
                              borderWidth: '2px'
                            },
                            '&:hover fieldset': {
                              borderColor: '#bb1ccc'
                            }
                          },
                          '& .MuiInputBase-input': {
                            padding: '12px 16px'
                          }
                        }}
                />
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4">
                <ColumnSelector
                  columns={filteredColumns}
                  selectedColumns={columnSelection[file.name] || []}
                  onToggleColumn={colId => handleToggleColumn(file.name, colId)}
                  onSelectAll={() => handleSelectAllColumns(file.name, filteredColumns.map(c => c.id))}
                  columnDetails={columnDetails[file.name] || {}}
                  onCdeChange={(colId, value) => handleCdeChange(file.name, colId, value)}
                  onDescriptionChange={(colId, value) => handleDescriptionChange(file.name, colId, value)}
                  onMetadataChange={(colId, value) => handleMetadataChange(file.name, colId, value)}
                  onTransformationLogicChange={(colId, value) => handleTransformationLogicChange(file.name, colId, value)}
                />
                    </div>
              </AccordionDetails>
            </Accordion>
                </div>
          );
        })}
          </div>
      </Box>
      </div>
    )
}

export default ColumnSelection;